module.exports = __webpack_public_path__ + "static/media/logo6.66262b06.svg";